import React, { Component } from 'react';
import PropTypes from 'prop-types';

import arrowD from './img/arrow_d.svg';
import arrowUP from './img/arrow_up.svg';
import './styles.scss';

class CarsActiveTableRowFunc extends Component {
  constructor () {
    super();
    this.state = {
      activeSearch: '',
      upDown: false
    };
  }
  setSeatch = (field) => {
    this.setState({
      activeSearch: field,
      upDown: field === this.state.activeSearch ? !this.state.upDown : true
    });
    this.props.sortTable(field, field === this.state.activeSearch ? !this.state.upDown : true);
  }
  toggleCheckbox = (e) => {
    this.props.selctAllRows(e);
  }
  render() {
    return (
      <div className="body-CarsActiveTableRowFunc">
        <div className="cell-CarsActiveTableRowFunc">
          <input
            id="selAll"
            type="checkbox"
            onChange={this.toggleCheckbox}
          />
          <label
            htmlFor="selAll"
          ><span />
          </label>
        </div>
        {/* <div className="cell-CarsActiveTableRowFunc">Activity</div>
        <div className="cell-CarsActiveTableRowFunc">ID</div> */}
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Product')}>
          Product page
          {this.state.activeSearch === 'Product' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Type')}>
          Type
          {this.state.activeSearch === 'Type' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Manufacturer')}>
          Manufacturer
          {this.state.activeSearch === 'Manufacturer' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Car')}>
          Car model
          {this.state.activeSearch === 'Car' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Year')}>
          Year
          {this.state.activeSearch === 'Year' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Mileag')}>
          Mileag
          {this.state.activeSearch === 'Mileag' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Transmission')}>
          Transmission
          {this.state.activeSearch === 'Transmission' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Fuel')}>
          Fuel type
          {this.state.activeSearch === 'Fuel' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
        <div className="cell-CarsActiveTableRowFunc">
          <button onClick={() => this.setSeatch('Vehicte')}>
          Vehicle cost
          {this.state.activeSearch === 'Vehicte' ?
            <img src={this.state.upDown ? arrowD : arrowUP} alt="arrow_pic" />
          : ''}
          </button>
        </div>
      </div>
    );
  }
}

// CarsActiveTableRowFunc.defaultProps = {
//   selctAllRows: PropTypes.func.isRequired
// };

CarsActiveTableRowFunc.propTypes = {
  selctAllRows: PropTypes.func.isRequired,
  sortTable: PropTypes.func.isRequired
};
export default CarsActiveTableRowFunc;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/carsActiveTableRowFunc/index.js